import React, { Children } from 'react'
import {
  Beta,
  IconChevronLeftDefault,
  IconChevronRightDefault,
} from '../../components'
import { CarouselProps } from './Carousel'

type CarouselModernProps = {
  title: React.ReactNode
  noPages?: boolean
  arrowCls?: string
  arrowSize?: 'sm' | 'md' | 'lg' | 'scale-8' | number
  rightArrowCls?: string
  leftArrowCls?: string
  pagesCls?: string
  autoScrollRate?: number
} & CarouselProps &
  React.ComponentProps<typeof Beta.CarouselV2.CarouselContent>

export const CarouselModern = ({
  title,
  srLabel,
  noPages,
  children,
  arrowCls = '',
  arrowSize = 'md',
  rightArrowCls = '',
  leftArrowCls = '',
  pagesCls = '',
  loops,
  autoScrollRate,
  scrollCount,
  onClickNext,
  onClickPrev,
  ...props
}: CarouselModernProps) => (
  <Beta.CarouselV2.Carousel
    srLabel={srLabel}
    loops={loops}
    scrollCount={scrollCount}
    onClickNext={onClickNext}
    onClickPrev={onClickPrev}
    {...props}
  >
    {autoScrollRate && <Beta.CarouselV2.AutoScroll rate={autoScrollRate} />}
    <div className='row small-gutters justify-content-end align-items-center'>
      <div className='col'>{title}</div>

      <div className='d-flex'>
        <div className={`col-auto ${arrowCls} ${leftArrowCls}`}>
          <Beta.CarouselV2.CarouselPrevious
            kind='secondary'
            size='xs'
            symmetrical
            rounded
          >
            <IconChevronLeftDefault size={arrowSize} />
          </Beta.CarouselV2.CarouselPrevious>
        </div>

        <div className={`col-auto ${arrowCls} ${rightArrowCls}`}>
          <Beta.CarouselV2.CarouselNext
            kind='secondary'
            size='xs'
            symmetrical
            rounded
          >
            <IconChevronRightDefault size={arrowSize} />
          </Beta.CarouselV2.CarouselNext>
        </div>
      </div>
    </div>

    <Beta.CarouselV2.CarouselContent {...props}>
      {Children.map(children, (child, index) => (
        <Beta.CarouselV2.CarouselItem key={index}>
          {child}
        </Beta.CarouselV2.CarouselItem>
      ))}
      {loops &&
        Children.map(children, (child, index) => (
          <Beta.CarouselV2.CarouselItem key={index}>
            {child}
          </Beta.CarouselV2.CarouselItem>
        ))}
    </Beta.CarouselV2.CarouselContent>

    {!noPages && <Beta.CarouselV2.CarouselPages className={pagesCls} />}
  </Beta.CarouselV2.Carousel>
)
